<div class="remuneration-container row" *ngIf="!isFilterData">
    <div class="remuneration-note">
        Please validate all fields as registered with us to know the details of
        Executive Remuneration in accordance with SEBI Master Circular Point No. 5.12 dated May 19, 2023.
    </div>
    <mat-card class="margin-top-35">
        <form class="remuneration-form" (ngSubmit)="f.form.valid && submitRemuneration()" #f="ngForm" novalidate>
            <div class="form-group">
                <mat-form-field>
                    <mat-label>Folio No</mat-label>
                    <input type="number" matInput [(ngModel)]="foloioNo" name="folio"
                        #folio="ngModel" required>
                </mat-form-field>
            </div>
            <div class="row">
                <div class="col-md-6 col-lg-6">
                    <div class="form-group padding-right-10">
                        <mat-form-field>
                            <mat-label>Bank Account No</mat-label>
                            <input type="text" matInput [(ngModel)]="bankAccountNo"
                                name="accountno" #accountno="ngModel" required>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                        <mat-form-field>
                            <mat-label>Primary Holder PAN No</mat-label>
                            <input type="text" matInput 
                                [(ngModel)]="primaryPanNumber" name="pan" #pan="ngModel" required>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="remuneration-terms-condition">
                <strong>
                    <p class="font-20">Declaration / confirmation</p>
                </strong>
                <div class="remuneration-terms-condition-align">
                    <span>-</span>
                    <p>
                        I hereby declare that I am an existing investor in the scheme(s) of
                        ITI Mutual Fund.
                    </p>
                </div>
                <div class="remuneration-terms-condition-align">
                    <span>-</span>
                    <p>
                        I hereby declare that the details provided by me are true and
                        correct.
                    </p>
                </div>
                <div class="remuneration-terms-condition-align">
                    <span>-</span>
                    <p>
                        I understand that the remuneration details (herein after referred to
                        as data) provided are sensitive and personal and therefore is being
                        furnished strictly for servicing my specific request for the same.
                    </p>
                </div>
                <div class="remuneration-terms-condition-align">
                    <span>-</span>
                    <p>
                        I understand that, no part of this data should be reproduced,
                        shared, published, distributed, displayed, performed, copied or
                        stored for public or private use in any information retrieval
                        system, or transmitted in any form by any mechanical, photographic
                        or electronic process, including electronically or digitally on the
                        internet or World Wide web, or over any network or local area
                        network.
                    </p>
                </div>
                <div class="remuneration-terms-condition-align">
                    <span>-</span>
                    <p>
                        I understand that, no part of this data should be modified or
                        changed or exploited in any way, or used to construct any kind of
                        database, or mirrored at any other location.
                    </p>
                </div>
                <mat-checkbox [(ngModel)]="termsAndCondition" name="tandc" #tandc="ngModel" required>
                    I agree to the above terms & conditions
                </mat-checkbox>
            </div>
            <div class="remuneration-action margin-top-50">
                <button mat-raised-button color="primary" class="mat-button-large" type="submit" [disabled]="!f.valid">
                    Submit
                </button>
            </div>
        </form>
    </mat-card>

</div>
<!---TEMPLATE DATA-->
<div class="files-container " *ngIf="isFilterData">
    <ng-template [ngIf]="filteredData.length > 0">
        <div class="article-heading2">Executive Remuneration</div>
        <div class="file-list-section" [ngClass]="{'border-btm': !last}"
            *ngFor="let subItem of filteredData; let i=index;let last=last;">

            <div class="file-list-section--name">
                {{subItem.title}}
            </div>
            <div class="file-list-section--actions">
                <img src="assets/icons/icon_" class="view-img cursor-pointer" (click)="viewFile(subItem.url)">
                &nbsp;
                <span class="tab-seperator"></span>
                &nbsp;
                <file-download [path]="subItem.url"></file-download>
            </div>
        </div>
    </ng-template>
    <ng-template [ngIf]="filteredData.length === 0">
        <span class="no-data">No data found for above selected criteria</span>
    </ng-template>
</div>